import { Component, Input, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { IDebt, ITag, IDebtsDataSource } from 'src/app/models/tag/tag.model';

@Component({
  selector: 'app-tag-viewer',
  templateUrl: './tag-viewer.component.html',
  styleUrls: ['./tag-viewer.component.scss']
})
export class TagViewerComponent {
    
    @Input() content!: ITag;
    @Input() showHeader = true;

    public rut = '';
    public today = '';

    public debtsDataSource = new MatTableDataSource<IDebtsDataSource>();
    public debtsDisplayedColumns: string[] = [
        'autopista',
        'monto',
        'vencimiento',
    ];

    @ViewChild(MatSort) sort?: MatSort;

    ngOnInit(): void {
        this.setRut();
        this.setToday();
        this.setAfiliadosDataSource();
    }

    ngAfterViewInit() {
        if (!this.sort) {
            return;
        }

        this.debtsDataSource.sort = this.sort;
    }

    setRut() {
        this.rut = this.content.DatosBasicosSolicitud.Rut + '-' + this.content.DatosBasicosSolicitud.DV
    }

    setToday() {
        this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) :
            new Date().getMonth() + 1)}${new Date().getDate()}`;
    }

    setAfiliadosDataSource() {
        this.debtsDataSource.data = this.content.Reporte.debts.map((debt: IDebt) => ({
            autopista: debt.name,
            monto: debt.amount,
            vencimiento: debt.expirationDate,
        }))
    }
}
